import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './TrabajadoresData.css';
import baseURL from '../../url';
import moneda from '../../moneda';
import { usePlan } from '../../PlanContext';

export default function TrabajadoresData() {
    const { esTienda } = usePlan();
    const [trabajadores, setTrabajadores] = useState([]);
    const [filtroDesde, setFiltroDesde] = useState(new Date().toISOString().split('T')[0]);
    const [filtroHasta, setFiltroHasta] = useState(new Date().toISOString().split('T')[0]);
    const [loading, setLoading] = useState(true);
    const [detalleVisible, setDetalleVisible] = useState(null);

    useEffect(() => {
        cargarStats();
    }, []);

    const cargarStats = () => {
        setLoading(true);
        const params = new URLSearchParams();
        if (filtroDesde) params.append('desde', filtroDesde);
        if (filtroHasta) params.append('hasta', filtroHasta);
        fetch(`${baseURL}/trabajadoresStats.php?${params}`)
            .then(r => r.json())
            .then(data => {
                setTrabajadores(data.trabajadores || []);
                setLoading(false);
            })
            .catch(err => { console.error(err); setLoading(false); });
    };

    const totalGeneral = trabajadores.reduce((sum, t) => sum + (t.totalVentas || 0), 0);
    const totalPedidos = trabajadores.reduce((sum, t) => sum + (t.cantidadPedidos || 0), 0);
    const mejorTrabajador = trabajadores.length > 0
        ? trabajadores.reduce((best, t) => (t.totalVentas || 0) > (best.totalVentas || 0) ? t : best, trabajadores[0])
        : null;

    const formatMoney = (n) => moneda + ' ' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    return (
        <div>
            <ToastContainer />

            <div className='trabFiltros'>
                <fieldset>
                    <legend>Desde</legend>
                    <input type='date' value={filtroDesde} onChange={(e) => setFiltroDesde(e.target.value)} />
                </fieldset>
                <fieldset>
                    <legend>Hasta</legend>
                    <input type='date' value={filtroHasta} onChange={(e) => setFiltroHasta(e.target.value)} />
                </fieldset>
                <button className='btnPost' onClick={cargarStats}>Filtrar</button>
            </div>

            <div className='trabResumenGeneral'>
                <div className='trabResumenCard'>
                    <span>Ventas Totales del Día</span>
                    <strong>{formatMoney(totalGeneral)}</strong>
                </div>
                <div className='trabResumenCard'>
                    <span>Total Pedidos</span>
                    <strong>{totalPedidos}</strong>
                </div>
                <div className='trabResumenCard'>
                    <span>Trabajadores Activos</span>
                    <strong>{trabajadores.filter(t => t.cantidadPedidos > 0).length}</strong>
                </div>
                {mejorTrabajador && mejorTrabajador.cantidadPedidos > 0 && (
                    <div className='trabResumenCard trabMejor'>
                        <span>Mejor Vendedor</span>
                        <strong>{mejorTrabajador.nombre}</strong>
                        <small>{formatMoney(mejorTrabajador.totalVentas)}</small>
                    </div>
                )}
            </div>

            {loading ? (
                <p style={{ textAlign: 'center', padding: '20px' }}>Cargando...</p>
            ) : trabajadores.length === 0 ? (
                <p style={{ textAlign: 'center', color: '#999', padding: '20px' }}>No hay trabajadores registrados</p>
            ) : (
                <div className='trabGrid'>
                    {trabajadores.map(trab => (
                        <div key={trab.idUsuario} className='trabCard'>
                            <div className='trabCardHeader'>
                                <div className='trabAvatar'>{trab.nombre.charAt(0).toUpperCase()}</div>
                                <div>
                                    <h3>{trab.nombre}</h3>
                                    <small>{trab.email}</small>
                                </div>
                            </div>
                            <div className='trabStats'>
                                <div className='trabStat'>
                                    <span>Ventas</span>
                                    <strong>{formatMoney(trab.totalVentas || 0)}</strong>
                                </div>
                                <div className='trabStat'>
                                    <span>Pedidos</span>
                                    <strong>{trab.cantidadPedidos || 0}</strong>
                                </div>
                                {!esTienda && (
                                    <div className='trabStat'>
                                        <span>Mesas</span>
                                        <strong>{trab.mesasAtendidas || 0}</strong>
                                    </div>
                                )}
                            </div>
                            {trab.cantidadPedidos > 0 && (
                                <button
                                    className='trabDetalleBtn'
                                    onClick={() => setDetalleVisible(detalleVisible === trab.idUsuario ? null : trab.idUsuario)}
                                >
                                    {detalleVisible === trab.idUsuario ? 'Ocultar detalle' : 'Ver detalle'}
                                </button>
                            )}
                            {detalleVisible === trab.idUsuario && (
                                <div className='trabDetalle'>
                                    <table className='trabDetalleTable'>
                                        <thead>
                                            <tr>
                                                <th>Pedido</th>
                                                {!esTienda && <th>Mesa</th>}
                                                <th>Productos</th>
                                                <th>Total</th>
                                                <th>Estado</th>
                                                <th>Hora</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(trab.pedidos || []).map(p => (
                                                <tr key={p.idPedido}>
                                                    <td>#{p.idPedido}</td>
                                                    {!esTienda && <td>Mesa {p.mesaNumero || '—'}</td>}
                                                    <td>{(p.productos || []).map(pr => `${pr.cantidad}x ${pr.titulo}`).join(', ')}</td>
                                                    <td><strong>{formatMoney(parseFloat(p.total))}</strong></td>
                                                    <td>
                                                        <span className={`trabEstado ${p.estado === 'Entregado' ? 'entregado' : p.estado === 'Pendiente' ? 'pendiente' : 'proceso'}`}>
                                                            {p.estado}
                                                        </span>
                                                    </td>
                                                    <td>{new Date(p.createdAt).toLocaleTimeString()}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
